import {TimelineLite, TweenLite} from "gsap";
import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {PearlHarbor} from "../../PearlHarbor";

export class PearlHarborScatterWinRunner implements SimplePresentationRunner {
    private _mainTL: TimelineMax;
    private _controller: SimplePresentationRunnerController;

    private complete(): void {
        this._controller.finish();
    }

    shouldRun(): boolean {
        return PearlHarbor.model.scatterCount >= 3 && PearlHarbor.model.data.freespinTriggeredThisSpin;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        this._mainTL = new TimelineLite();
        this._mainTL.add(PearlHarbor.scatterAnimation.playWinAnim(), 0);
        if (this._mainTL.duration() == 0) {
            this._mainTL.add(TweenLite.to(this, {duration: 0.001}));
        }
        this._mainTL.add(() => this.complete());
    }
}